<!--
 * 字典选择器
-->
<template>
  <lin-select
    v-bind="$attrs"
    v-on="$listeners"
    :getPopupContainer="getSelectPopupContainer"
    :class="`dict-select dict-select--${isCheck ? 'check' : 'select'}`"
    :options="optionsComputed"
    :disabled="disabled || isCheck"
  ></lin-select>
</template>

<script>
import LinSelect from '@/components/LinSelect/index.vue'
import { mapMutations, mapGetters } from 'vuex'
import { getDictionaries } from '@/utils/helpers'

export default {
  name: 'DictSelect',
  components: {
    LinSelect
  },
  props: {
    dictCode: {
      type: String
    }, // 字典code
    valueField: {
      type: String,
      default: 'code'
    }, // value字段名
    isGetClass: {
      // 获取后端class
      type: Boolean,
      default: false
    },
    filterFn: {
      // 过滤函数，对已获取的选项进行过滤
      type: Function
    },
    valueHandle: {
      // 对value的处理，如 Number，String 等
      type: Function
    },
    mapFn: {
      // 遍历处理函数，对已获取的选项进行二次处理
      type: Function
    },
    options: {
      type: Array,
      default: () => [
        // {
        //   label: "选项1",
        //   value: "1",
        // },
        // {
        //   label: "选项2",
        //   value: "2",
        // }
      ]
    },
    // 是否默认选中首项
    isSelectFirst: {
      type: Boolean,
      default: false
    },
    // 是否查看，是则显示文本，否则显示下拉框
    isCheck: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    getPopupContainer: {
      type: Function,
      default: () => document.body
    },
    // 弹出容器是否挂载在父元素中
    isParentNodePopupContainer: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      dictOptions: []
    }
  },
  computed: {
    ...mapGetters('dicts', ['getterDictDataList']),
    getSelectPopupContainer() {
      return this.isParentNodePopupContainer
        ? (triggerNode) => triggerNode.parentNode
        : this.getPopupContainer
    },
    dictData() {
      return this.getterDictDataList[this.dictCode] || []
    },
    hasDictData() {
      return this.dictData && this.dictData.length > 0
    },
    optionsComputed() {
      if (this.options?.length) {
        return this.options
      }

      let options = _.cloneDeep(this.dictOptions)

      if (this.filterFn) {
        return options.filter(this.filterFn)
      }

      if (this.valueField) {
        options.forEach(item => item.value = item.row[this.valueField])
      }

      if (this.valueHandle) {
        options.forEach(item => item.value = this.valueHandle(item.value))
      }

      if (this.mapFn) {
        return options.map(this.mapFn)
      }

      return options
    }
  },
  watch: {
    dictCode: {
      async handler() {
        if (!this.dictCode || this.hasDictData) {
          this.dictOptions = this.dictData || []
        } else if (this.dictCode && !this.hasDictData) {
          this.dictOptions = this.isGetClass
            ? await this.getColValCommentList()
            : await this.getDictData()
          this.SET_DICT_DATA_LIST({
            dictData: _.cloneDeep(this.dictOptions),
            dictCode: this.dictCode
          })
        }

        this.$emit('loaded', this.dictOptions)

        if (this.isSelectFirst && this.dictOptions.length > 0) {
          this.$emit('change', this.dictOptions[0].value)
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('dicts', ['SET_DICT_DATA_LIST']),
    // 获取字典
    async getDictData() {
      return await getDictionaries(this.dictCode, {
        returnOptions: true,
      })
    },
    // 获取后端类数据
    async getColValCommentList() {
      const { data } = await this.$axios.post(
        `/${process.env.VUE_APP_PROXY_DING_OA}/dictionary/getColValCommentList?classStr=${this.dictCode}`
      )
      return data && data.length > 0
        ? data.map((item) => ({
            label: item.name,
            value: item[this.valueField],
            row: item
          }))
        : []
    }
  }
}
</script>

<style lang="scss" scoped>
.dict-select {
  &--check {
    /deep/ .ant-select-selection {
      background-color: #fff;
      border: none;
      cursor: default;
      .ant-select-selection__rendered {
        color: rgba(0, 0, 0, 0.65);
        margin: 0;
      }
      .ant-select-arrow {
        display: none;
      }
    }
  }
}
</style>
